var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"machinery-manufactur"},[_c('s-r-m-header',{ref:"header"}),_c('IndustryDesc',{ref:"industryDesc",attrs:{"industryInfo":_vm.industryInfo}}),_c('ProjectDesc',{attrs:{"descInfo":{
      title: '工业制造行业业务特征',
      description: '璞华易研PLM提供适用于机械制造行业的研发管理解决方案',
      redContent: '工业设备等制造业',
      content: '的分工合作越来越细，而部门的相对独立以及客户化定制要求，导致产品研发周期长且协同较少，研发部门到生产部门往往只有纸质文件传递，这对企业的设计生产方式、管理模式提出了严峻挑战。企业实施PLM系统可以使产品开发管理更加精细化，通过细化项目管理颗粒度，打破研发过程中部门之间的壁垒，从而实现研发、工艺、制造计划的协同分工与统筹安排。璞华易研PLM能帮助企业在研发管理方面极大提升工作效率，实现上游技术部门和下游生产制造部门之间信息及时传递。'
    }}}),_c('ProblemSolving',{attrs:{"textList":_vm.textList}}),_c('AppBenefits'),_c('CompanyInfo',{attrs:{"projectInfo":_vm.projectInfo}}),_c('ResultsOperation',{attrs:{"descInfo":{
      title: '运营效果',
      descArr1: [
        '建立统一的公司级产品数据管理平台',
        '降本增效、较少数据冗余',
        '通过系统完整记录产品的研发过程、变更记录及版本控制',
        '规范并固化设计变更管理流程，实现对所有技术数据变更的可追溯',
      ]
    }}}),_c('ChooseUs',{attrs:{"nameVals":['EquipmentManufacturing']}}),_c('custom-form',{ref:"customForm"}),_c('footer-box')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }